const messages: Record<string, string> = {
  INVALID_PASSWORD: '当前密码不正确。', PASSKEY_LIMIT: '最多可添加 10 个通行密钥。',
  PASSKEY_EXISTS: '此通行密钥已添加。', PASSKEY_CHALLENGE_EXPIRED: '验证已过期，请重试。',
  PASSKEY_VERIFICATION_FAILED: '通行密钥验证失败，请重试或使用密码登录。',
  PASSKEY_ORIGIN_MISMATCH: '请通过 talk.zhuozhixing.xyz 使用通行密钥。',
  PASSKEY_UNAVAILABLE: '通行密钥暂不可用，请使用密码登录。',
  INVALID_INPUT: '请检查提交的数值。', NOT_FOUND: '该资源已不存在。',
  INSUFFICIENT_BALANCE: '此次调整会使余额变为负数。', INVALID_BALANCE: '余额超出支持范围。',
  PROVIDER_MISMATCH: '模型与渠道必须使用同一提供商。', PRICE_DATE_CONFLICT: '请选择晚于最新价格版本的生效时间。',
  RESOURCE_CONFLICT: '该资源与现有记录冲突，或仍在使用中。',
  REQUEST_NOT_FOUND: '该计费请求已不存在，请刷新计费列表。',
  ACCOUNTING_NOT_RETRYABLE: '该请求不可重试，请查看其当前计费状态。',
  CHAT_ACCOUNTING_UNAVAILABLE: '计费服务暂时不可用，请刷新后重试。',
  BILLING_SETTLEMENT_FAILED: '结算未完成，请先查看当前状态再重试。',
};
export class AdminApiError extends Error {
  constructor(readonly status: number, readonly code?: string) {
    super((code === undefined ? undefined : messages[code]) ?? (status === 401 ? '请先登录后继续。' : status === 403 ? '需要管理员权限。' :
      status === 400 ? '请检查提交的数值。' : '请求失败，请重试。'));
    this.name = 'AdminApiError';
  }
}
export function adminErrorMessage(error: unknown): string {
  return error instanceof AdminApiError ? error.message : '请求失败，请重试。';
}
export async function adminFetch<T>(path: string, options: { method?: string; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  const configured = import.meta.env.VITE_API_BASE_URL as string | undefined;
  const base = (configured?.trim() === '' ? '/api' : configured?.trim() ?? '/api').replace(/\/+$/, '');
  let response: Response;
  try {
    response = await fetch(`${base}/v1${path}`, {
      method: options.method ?? 'GET', credentials: 'include', cache: 'no-store', signal: options.signal,
      headers: options.body === undefined ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: options.body === undefined ? undefined : JSON.stringify(options.body),
    });
  } catch { throw new AdminApiError(0); }
  let payload: unknown;
  try { payload = await response.json(); } catch { throw new AdminApiError(response.ok ? 502 : response.status); }
  if (!response.ok) {
    const code = payload && typeof payload === 'object' && 'error' in payload && typeof payload.error === 'string' ? payload.error : undefined;
    throw new AdminApiError(response.status, code);
  }
  return payload as T;
}
